<template>
  <div class="account-page" :class="{ active }" :data-account-page="id">
    <div class="inner">
      <form :class="{ loading: loading }" @submit.prevent="saveCompany">
        <div class="heading-custom">
          <h4 class="font-md wt-md">Company details</h4>
          <!-- <template v-if="$store.getters['user/isHirer']">
            <span
              class="tags tags-desktop"
              v-if="!$store.getters['user/stripeCard']"
            >
              <span class="alert-tag error"
                >Please complete your payment details</span
              >
            </span>
          </template>
          <template v-else>
            <span
              class="tags tags-desktop"
              v-if="!$store.getters['user/stripeConnectIsOnboarded']"
            >
              <span class="alert-tag error"
                >Please complete your payment details</span
              >
            </span>
          </template -->
          >
        </div>
        <company-fields
          :data.sync="company"
          :errors="errors"
          :form_options="form_options"
          @selected="gst_not_appplicable_handler"
          @deselected="gst_appplicable_handler"
        ></company-fields>
        <billing-address-fields
          :data.sync="company"
          :errors="errors"
          :form_options="form_options"
        ></billing-address-fields>
        <div class="form-group vanilla submit">
          <div class="multi-action">
            <div class="form-action align-left">
              <button
                type="button"
                class="button muted interactive"
                @click="navigateBack"
              >
                <svg-icon id="arrowLeft"></svg-icon>
                <span>Back</span>
              </button>
            </div>
            <div class="form-action align-right">
              <loader-button
                type="submit"
                :loading="loading"
                label="Save and Continue"
                after-icon="arrowRight"
              ></loader-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";
import AccountSubpage from "../../../AccountSubpage";
import CompanyFields from "../main/shared-fields/Company";
import { fields as company } from "../main/shared-fields/Company";
import BillingAddressFields from "../main/shared-fields/BillingAddress";
import { fields as billingAddress } from "../main/shared-fields/BillingAddress";
import { mapGetters } from "vuex";

export default {
  extends: AccountSubpage,
  mounted() {
    this.$eventBus.$on("accountNavigate", (mutation) => {
      if (
        mutation.payload.page === "profile-company" &&
        mutation.payload.pane === "complete-profile"
      ) {
        this.assignProfileDataFromStore();
      }
    });
    this.assignProfileDataFromStore();
    this.form_options = this.$root.$refs.accountPanel.formOptions;
  },
  components: {
    CompanyFields,
    BillingAddressFields,
  },
  data() {
    return {
      id: "profile-company",
      company: merge(company, billingAddress),
      form_options: {},
      loading: false,
      errors: {
        "billing_address.sub_premises_number": null,
        "billing_address.street_number": null,
        "billing_address.street_address": null,
        "billing_address.suburb": null,
        "billing_address.state.slug": null,
        "billing_address.postal_code": null,
      },
    };
  },
  methods: {
    gst_not_appplicable_handler() {
      this.company.gst = 0;
    },

    gst_appplicable_handler() {
      this.company.gst = 1;
    },
    assignProfileDataFromStore() {
      this.$nextTick(() => {
        this.company = cloneDeep(this.account);
      });
    },
    navigateBack() {
      this.$store.commit("account/navigateTo", {
        pane: "complete-profile",
        page: "profile-details",
      });
    },
    saveCompany() {
      if (this.company.gst == 0) {
        this.company.abn = null;
        this.company.business_name = null;
      }
      if (!this.loading) {
        this.loading = true;
        this.errors = [];

        axios
          .put("/api/account/complete-profile/company", this.company)
          .then((response) => {
            this.$store.commit("user/updateAccount", response.data);
            this.$store.commit("account/navigateTo", {
              pane: "complete-profile",
              page: "profile-payment",
            });
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.$toasted.show(
                "Your company details could not be updated, please review errors and try again.",
                {
                  type: "error",
                }
              );
              return (this.errors = error.response.data.errors);
            }
            this.$toasted.show(
              "Oops! We couldn't update your company details, please refresh the page and try again.",
              {
                type: "error",
              }
            );
          })
          .then(() => {
            this.$store.dispatch("user/refreshUser");
            this.loading = false;
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      account: "user/account",
    }),
  },
};
</script>
